module.exports = __webpack_public_path__ + "static/media/42.edf9c963.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/42.png
// module id = 466
// module chunks = 0